/* ============================================================
   KHAVIYAR cart drawer (24 Oct 2026)

   Amin: "As soon as someone clicks buy now or add to cart or preorder button and after the
   upsell and cross pop up is dismissed selected, immediately pop up the cart with the items
   added and easily allow them to checkout. And make sure it's mobile friendly."

   - window.KHCart.open()   opens the drawer and re-reads /cart.js (always fresh).
   - window.KHCart.hold(ms) tells the drawer a popup flow owns this add (kh-upsell calls it on
                            click); the popup then calls KHCart.open() when it is dismissed or
                            accepted, so the drawer never fights the popup.
   - Any successful POST to /cart/add that nobody is holding (theme add to cart, quick add,
     the Caviar Table popup, accessories) opens the drawer by itself.
   - Lines: image, name, size, the discount that applied, quantity stepper, remove.
     Footer: savings, subtotal, one free-delivery line, a full-width Checkout button.
   - Mobile: full-screen sheet under 640px, 44px+ tap targets, safe-area padding, iOS scroll lock.
   Copy rules: few words, no em dashes, never a stock count.
   ============================================================ */
(function () {
  'use strict';
  if (window.KHCart) return;

  var FREE_SAMEDAY = 19995;   // free refrigerated or same-day delivery from $199.95
  var FREE_ALL = 29995;       // free Express Delivery too from $299.95
  var root = null, isOpen = false, heldUntil = 0, busy = false, lastFocus = null;

  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var CSS = '' +
  '.khcd{position:fixed;inset:0;z-index:2147483000;font-family:Lora,Georgia,serif;color:#000e34}' +
  '.khcd[hidden]{display:none}' +
  '.khcd__bg{position:absolute;inset:0;background:rgba(6,8,18,.55);opacity:0;transition:opacity .25s ease}' +
  '.khcd__panel{position:absolute;top:0;right:0;bottom:0;width:min(440px,100%);background:#faf9f7;display:flex;flex-direction:column;' +
  ' transform:translateX(100%);transition:transform .28s cubic-bezier(.2,.7,.2,1);box-shadow:-12px 0 40px rgba(0,0,0,.18);outline:none}' +
  '.khcd.is-open .khcd__bg{opacity:1}.khcd.is-open .khcd__panel{transform:none}' +
  '.khcd__head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:calc(14px + env(safe-area-inset-top)) 18px 12px;border-bottom:1px solid rgba(0,14,52,.12)}' +
  '.khcd__t{margin:0;font-family:Rosarivo,Georgia,serif;font-weight:400;font-size:22px;line-height:1.2}' +
  '.khcd__t small{font-family:Lora,Georgia,serif;font-size:14px;color:rgba(0,14,52,.6);margin-left:6px}' +
  '.khcd__x{width:44px;height:44px;flex:none;border:1px solid rgba(0,14,52,.18);border-radius:50%;background:#fff;color:#000e34;font-size:22px;line-height:1;cursor:pointer}' +
  '.khcd__body{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:4px 18px}' +
  '.khcd__list{list-style:none;margin:0;padding:0}' +
  '.khcd__item{display:grid;grid-template-columns:76px 1fr;gap:14px;padding:16px 0;border-bottom:1px solid rgba(0,14,52,.1)}' +
  '.khcd__img{display:block;width:76px;height:76px;border-radius:8px;overflow:hidden;background:#fff;border:1px solid rgba(0,14,52,.08)}' +
  '.khcd__img img{width:100%;height:100%;object-fit:cover;display:block}' +
  '.khcd__name{display:block;color:#000e34;text-decoration:none;font-size:16px;line-height:1.3;font-weight:500}' +
  '.khcd__var{display:block;font-size:14px;color:rgba(0,14,52,.65);margin-top:2px}' +
  '.khcd__deal{display:block;font-size:13px;color:#8a6d2f;margin-top:4px}' +
  '.khcd__row{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:10px}' +
  '.khcd__qty{display:inline-flex;align-items:center;border:1px solid rgba(0,14,52,.2);border-radius:999px;background:#fff}' +
  '.khcd__qty button{width:44px;height:40px;border:0;background:none;font-size:20px;line-height:1;color:#000e34;cursor:pointer}' +
  '.khcd__qty span{min-width:22px;text-align:center;font-size:16px;font-variant-numeric:tabular-nums}' +
  '.khcd__price{font-size:16px;font-weight:600;white-space:nowrap;text-align:right}' +
  '.khcd__price s{display:block;font-weight:400;font-size:13px;color:rgba(0,14,52,.5)}' +
  '.khcd__rm{margin-top:6px;padding:6px 0;border:0;background:none;font:inherit;font-size:13px;color:rgba(0,14,52,.6);text-decoration:underline;cursor:pointer}' +
  '.khcd__foot{border-top:1px solid rgba(0,14,52,.12);padding:14px 18px calc(14px + env(safe-area-inset-bottom));background:#fff}' +
  '.khcd__line{display:flex;justify-content:space-between;gap:10px;font-size:15px;margin:0 0 6px}' +
  '.khcd__line--save{color:#8a6d2f}' +
  '.khcd__line--total{font-size:18px;font-weight:600;margin:8px 0 4px}' +
  '.khcd__free{margin:0 0 12px;font-size:14px;color:rgba(0,14,52,.75)}' +
  '.khcd__free b{color:#000e34}' +
  '.khcd__go{display:flex;align-items:center;justify-content:center;width:100%;min-height:56px;border:0;border-radius:6px;background:#000e34;color:#fff;' +
  ' text-decoration:none;font-family:Montserrat,Arial,sans-serif;font-size:14px;letter-spacing:2px;text-transform:uppercase;cursor:pointer}' +
  '.khcd__go:hover{background:#0b1d52}' +
  '.khcd__more{display:block;width:100%;margin-top:8px;min-height:44px;border:0;background:none;font:inherit;font-size:15px;color:#000e34;text-decoration:underline;cursor:pointer}' +
  '.khcd__note{margin:8px 0 0;text-align:center;font-size:12.5px;color:rgba(0,14,52,.6)}' +
  '.khcd__empty{padding:40px 0 12px;text-align:center;font-size:16px}' +
  '.khcd__load{padding:40px 0;text-align:center;color:rgba(0,14,52,.6)}' +
  '.khcd.is-busy .khcd__body{opacity:.55;pointer-events:none}' +
  '.khcd__item>div{min-width:0}.khcd__img img{object-fit:contain}.khcd__row{flex-wrap:wrap}' +
  '@media (max-width:640px){.khcd__panel{width:100%;height:100%;height:100dvh}.khcd__t{font-size:20px}}' +
  '@media (max-width:380px){.khcd__item{grid-template-columns:60px 1fr;gap:12px}.khcd__img{width:60px;height:60px}.khcd__qty button{width:38px;height:38px}.khcd__body,.khcd__foot{padding-left:14px;padding-right:14px}}' +
  '@media (prefers-reduced-motion:reduce){.khcd__panel,.khcd__bg{transition:none}}';

  /* ---------- scroll lock that holds on iOS Safari ---------- */
  var SY = 0, locked = false;
  function lock() {
    if (locked) return;
    locked = true;
    SY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed'; b.style.top = -SY + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body;
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, SY);
  }

  function build() {
    if (root) return;
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    root = document.createElement('div');
    root.className = 'khcd';
    root.hidden = true;
    root.innerHTML =
      '<div class="khcd__bg" data-khcd-close></div>' +
      '<aside class="khcd__panel" role="dialog" aria-modal="true" aria-labelledby="khcd-title" tabindex="-1">' +
        '<header class="khcd__head"><h2 class="khcd__t" id="khcd-title">Your cart<small data-khcd-count></small></h2>' +
        '<button type="button" class="khcd__x" data-khcd-close aria-label="Close cart">&times;</button></header>' +
        '<div class="khcd__body" data-khcd-body><p class="khcd__load">Loading&hellip;</p></div>' +
        '<footer class="khcd__foot" data-khcd-foot hidden></footer>' +
      '</aside>';
    document.body.appendChild(root);
    root.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function trapFocus(e) {
    var f = root.querySelectorAll('a[href],button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function announce(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { itemCount: cart.item_count, source: 'kh-cart-drawer' } } }));
    } catch (e) {}
    var n = cart.item_count;
    document.querySelectorAll('[data-kh-cart-count], .pt-header__count, .cart-count-bubble span, cart-count, .header-actions__cart-icon .cart-bubble__text').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
    });
  }

  function lineDeal(it) {
    var a = it.line_level_discount_allocations || [];
    return a.filter(function (x) { return x.amount > 0; }).map(function (x) {
      var t = (x.discount_application && x.discount_application.title) || 'Saving';
      return '<span class="khcd__deal">' + esc(t) + ' &minus;' + money(x.amount) + '</span>';
    }).join('');
  }

  function render(cart) {
    var body = root.querySelector('[data-khcd-body]');
    var foot = root.querySelector('[data-khcd-foot]');
    var count = root.querySelector('[data-khcd-count]');
    count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="khcd__empty">Your cart is empty.</p>';
      foot.hidden = false;
      foot.innerHTML = '<button type="button" class="khcd__go" data-khcd-close>Keep shopping</button>';
      return;
    }
    // Shopify lists the newest line first; show them in the order they were added (caviar first),
    // keeping each line's real 1-based index for /cart/change.js.
    var rows = cart.items.map(function (it, i) { return { it: it, i: i }; }).reverse();
    body.innerHTML = '<ul class="khcd__list">' + rows.map(function (row) {
      var it = row.it, i = row.i;
      var name = String(it.product_title || it.title || '').split(' | ')[0];
      var variant = it.variant_title && !/default title/i.test(it.variant_title) ? it.variant_title : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var line = i + 1;
      return '<li class="khcd__item">' +
        '<a class="khcd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="" width="76" height="76" decoding="async">' : '') + '</a>' +
        '<div>' +
          '<a class="khcd__name" href="' + esc(it.url) + '">' + esc(name) + '</a>' +
          (variant ? '<span class="khcd__var">' + esc(variant) + '</span>' : '') +
          lineDeal(it) +
          '<div class="khcd__row">' +
            '<div class="khcd__qty">' +
              '<button type="button" data-khcd-line="' + line + '" data-khcd-q="' + (it.quantity - 1) + '" aria-label="One fewer ' + esc(name) + '">&minus;</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-khcd-line="' + line + '" data-khcd-q="' + (it.quantity + 1) + '" aria-label="One more ' + esc(name) + '">+</button>' +
            '</div>' +
            '<span class="khcd__price">' + was + money(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="khcd__rm" data-khcd-line="' + line + '" data-khcd-q="0">Remove</button>' +
        '</div>' +
      '</li>';
    }).join('') + '</ul>';

    var html = '';
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.total_allocated_amount > 0) html += '<p class="khcd__line khcd__line--save"><span>' + esc(d.title) + '</span><span>&minus;' + money(d.total_allocated_amount) + '</span></p>';
    });
    if (cart.total_discount > 0) html += '<p class="khcd__line khcd__line--save"><span>You save</span><span>' + money(cart.total_discount) + '</span></p>';
    html += '<p class="khcd__line khcd__line--total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></p>';
    var t = cart.total_price;
    // The shipping worker measures free delivery on the item prices Shopify sends with the rate
    // request, which are the prices before discounts, so measure the same way here.
    var base = cart.original_total_price || t;
    if (base < FREE_SAMEDAY) html += '<p class="khcd__free"><b>' + money(FREE_SAMEDAY - base) + '</b> more for free refrigerated or same-day delivery.</p>';
    else if (base < FREE_ALL) html += '<p class="khcd__free"><b>Free refrigerated or same-day delivery</b> unlocked.</p>';
    else html += '<p class="khcd__free"><b>Free delivery</b> unlocked.</p>';
    html += '<a class="khcd__go" href="/checkout">Checkout &middot; ' + money(t) + '</a>';
    html += '<button type="button" class="khcd__more" data-khcd-close>Keep shopping</button>';
    html += '<p class="khcd__note">Dispatch and arrival days show at checkout.</p>';
    foot.innerHTML = html;
    foot.hidden = false;
  }

  function refresh() {
    return getCart().then(function (c) { if (root) render(c); announce(c); return c; });
  }

  function change(line, q) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(q)) })
    }).then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.items) { render(c); announce(c); } else return refresh(); })
      .catch(function () { return refresh(); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var q = t.closest('[data-khcd-line]');
    if (q) { e.preventDefault(); change(q.getAttribute('data-khcd-line'), q.getAttribute('data-khcd-q')); return; }
    if (t.closest('[data-khcd-close]')) { e.preventDefault(); close(); }
  }

  function closeOtherOverlays() {
    // A quick-add modal or the theme's own drawer must not sit on top of (or under) the cart.
    document.querySelectorAll('dialog[open]').forEach(function (d) {
      var tag = (d.id || '') + ' ' + (d.className || '');
      if (/quick-add|cart|drawer/i.test(tag)) { try { d.close(); } catch (e) {} }
    });
  }

  function open() {
    heldUntil = 0;
    build();
    closeOtherOverlays();
    if (!isOpen) {
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      lock();
      void root.offsetWidth;            // force a reflow so the slide-in transition always runs
      root.classList.add('is-open');
      setTimeout(function () { var p = root.querySelector('.khcd__panel'); if (p) p.focus({ preventScroll: true }); }, 60);
    }
    return refresh();
  }

  function close() {
    if (!root || !isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    setTimeout(function () { if (!isOpen) root.hidden = true; }, 300);
    unlock();
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- open after any add nobody else is handling ---------- */
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = _fetch.apply(this, arguments);
      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          setTimeout(function () { if (Date.now() > heldUntil) open(); }, 150);
        }).catch(function () {});
      }
      return p;
    };
  }

  window.KHCart = {
    open: open,
    close: close,
    refresh: refresh,
    hold: function (ms) { heldUntil = Date.now() + (ms || 15000); },
    release: function () { heldUntil = 0; }
  };
})();
